<template>
  <div>
    <h6>
      Changed in this turn <span class="text-muted">({{ total }})</span>
    </h6>
    <p v-if="total > changes.length" class="small text-muted">
      Showing the first {{ changes.length }} of {{ total }} changes.
    </p>
    <p v-if="!total" class="small text-muted">No recorded draft changes.</p>
    <div v-for="change in changes" :key="change.path" class="change">
      <code>{{ change.path }}</code
      ><span class="before">{{
        change.kind === "added" ? "—" : format(change.before)
      }}</span
      ><span>→</span
      ><span class="after">{{
        change.kind === "removed" ? "—" : format(change.after)
      }}</span>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { DraftChange } from "./aiConversationsTypes";
defineProps<{ changes: DraftChange[]; total: number }>();
const format = (value: unknown) =>
  value === undefined ? "—" : JSON.stringify(value);
</script>
<style scoped lang="scss">
.change {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr) auto minmax(0, 1fr);
  gap: 0.5rem;
  padding: 0.4rem 0;
  border-bottom: 1px solid var(--phoenix-border-color);
  overflow-wrap: anywhere;
}
.before {
  color: #a43b3b;
}
.after {
  color: #26734d;
}
@media (max-width: 600px) {
  .change {
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  }
  .change code {
    grid-column: 1 / -1;
  }
}
</style>
